// import LoggedUserModel from './Common/LoggedUserModel';

export default function (options) {
    let Vuex = options.Vuex;

    return new Vuex.Store({
        state: {},
        mutations: {},
        actions: {},
        getters: {},
        modules: {
            // loggedUserModel: LoggedUserModel,
        }
    });

}